import type { NoteIntent, TunedNote } from "./types";
import type { Tuning } from "../data/instruments";
import { noteNameToFrequency } from "../lib/notes";
import { centsToFrequency, pitchRatioFromCents } from "./pitch";

export class TuningEngine {
  resolve(intent: NoteIntent, tuning: Tuning, extraCents = 0): TunedNote {
    const tuningNote = tuning.notes.find((note) => note.label === intent.noteName);
    const detuneCents =
      tuningNote?.cents !== undefined
        ? tuningNote.cents + extraCents
        : (tuning.detuneCents[intent.noteName] ?? 0) + extraCents;
    const frequency =
      tuningNote?.hz !== undefined
        ? tuningNote.hz * pitchRatioFromCents(extraCents)
        : tuningNote?.cents !== undefined
          ? centsToFrequency(tuning.tonicHz, tuningNote.cents + extraCents)
          : noteNameToFrequency(intent.noteName) * pitchRatioFromCents(detuneCents);

    return {
      id: intent.id,
      noteName: intent.noteName,
      frequency,
      velocity: intent.velocity,
      detuneCents,
      tuning,
      ornament: intent.ornament
    };
  }
}
